import ErrorOutlineIcon from "@mui/icons-material/ErrorOutlined";
import { CircularProgress } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { InlineHint } from "../../../components/UIToolkit/molecules/InlineHint";
import SystemBanner from "../../../components/UIToolkit/molecules/SystemBanner";

type Props = {
	isLoading: boolean;
	isError: boolean;
	dataTestId: string;
};

/** Renders the coverage request's non-data states without treating an error as an empty result. */
export const PbjPredictionJobCoverageStatus: FC<Props> = ({ isLoading, isError, dataTestId }) => {
	const { t } = useTranslation();

	if (isError) {
		return (
			<SystemBanner
				tone="error"
				icon={<ErrorOutlineIcon />}
				title={t("pbj_model.prediction.manual_hours.coverage_failed")}
				dataTestId={`${dataTestId}-error`}
			/>
		);
	}

	if (isLoading) {
		return (
			<InlineHint tone="info" icon={<CircularProgress size={16} aria-label={t("system.dropdown.loading")} />} dataTestId={`${dataTestId}-loading`}>
				{t("system.dropdown.loading")}
			</InlineHint>
		);
	}

	return null;
};
